import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import { RoutePrivateProps } from 'components/Route/Private/types';
import PlacementViewHidrator from 'components/Placement/View/Hidrator';

function ScreensPlacementsView(params: RoutePrivateProps) {
  return (
    <BaseLayout>
      <DocumentTitle>Placements View</DocumentTitle>
      <PlacementViewHidrator id={Number.parseInt(params.id as string, 10)} />
    </BaseLayout>
  );
}

export default ScreensPlacementsView;
